import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { unstable_HistoryRouter as Router } from 'react-router-dom';
import { StateProvider } from './provider';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import Main from './pages/Main';
import ReactGA from 'react-ga4';
import history from './libs/history';
import theme from './theme/theme';
import './assets/fonts/Montserrat-Regular.ttf';
import './assets/fonts/Montserrat-SemiBold.ttf';

function App() {
  ReactGA.initialize('G-Q3MY1TPP1N');

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router history={history}>
          <StateProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Main />
            </LocalizationProvider>
          </StateProvider>
        </Router>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;